import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { setupPwa } from "./pwa";
import { applyTheme } from "./theme";
import { applyTypography } from "./typography";
import "./fonts.css";
import "./styles.css";

// Before the first render, so a dark-mode override never flashes light.
applyTheme();
applyTypography();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
setupPwa();
